import { clsx } from 'clsx'
import { type FC } from 'react'

import { CartIntermediateAdBanner } from '../../CartIntermediateAdBanner/CartIntermediateAdBanner'
import { useCartIntermediateContext } from '../../hooks/useCartIntermediateContext'
import { CartIntermediateCtaButtons } from '../CartIntermediateCtaButtons/CartIntermediateCtaButtons'
import { CartIntermediateProductInfo } from '../CartIntermediateProductInfo/CartIntermediateProductInfo'

import styles from './CartIntermediateProductWithButtonsSection.module.css'

type CartIntermediateProductWithButtonsSectionType = {
  handleClose: () => void
}
export const CartIntermediateProductWithButtonsSection: FC<
  CartIntermediateProductWithButtonsSectionType
> = ({ handleClose }) => {
  const { entries } = useCartIntermediateContext()
  const [mainProduct, recommendedProduct] = entries ?? []
  const hasRecommendedProduct = Boolean(recommendedProduct)

  return (
    <div
      className={clsx(
        'flex flex-col gap-y-2 tablet:grid tablet:grid-cols-2 tablet:gap-x-4 tablet:gap-y-2',
        hasRecommendedProduct
          ? styles['container-recomendations']
          : styles['container-no-recomendations'],
      )}
    >
      <div className={styles['product-main']}>
        <CartIntermediateProductInfo entry={mainProduct} />
      </div>

      {hasRecommendedProduct ? (
        <div className={styles['product-recommended']}>
          <CartIntermediateProductInfo entry={recommendedProduct} />
        </div>
      ) : null}

      <div className={styles.cta}>
        <CartIntermediateCtaButtons handleClose={handleClose} />
      </div>

      <div className={clsx('flex justify-center', styles.banner)}>
        <CartIntermediateAdBanner />
      </div>
    </div>
  )
}
